import OrderServiceBuildFormObject from "../../pages/service-order/OrderServiceBuildFormObject";
import {
  SELECT_SERVICEORDER,
  SERVICEORDER_CREATE_REQUEST_FAIL,
  SERVICEORDER_CREATE_REQUEST_SUCCESS,
  SERVICEORDER_FIND_REQUEST_FAIL,
  SERVICEORDER_FIND_REQUEST_SUCCESS,
  SERVICEORDER_UPDATE_REQUEST_FAIL,
  SERVICEORDER_UPDATE_REQUEST_SUCCESS,
  SERVICEORDER_CANCEL,
  SERVICEORDER_BILL,
  RESET_SERVICE_ORDER
} from "../action.types";
import initialValue from "../initial.state";

export default function(state = initialValue.serviceOrder, action) {
  switch (action.type) {
    case SELECT_SERVICEORDER:
      return { ...state, ...action.serviceorder };
    case SERVICEORDER_CREATE_REQUEST_SUCCESS:
      return { ...state, ...action.payload };
    case SERVICEORDER_CREATE_REQUEST_FAIL:
      return state;
    case SERVICEORDER_UPDATE_REQUEST_SUCCESS:
      return state;
    case SERVICEORDER_UPDATE_REQUEST_FAIL:
      return state;
    case SERVICEORDER_FIND_REQUEST_SUCCESS:
      return { ...OrderServiceBuildFormObject(action.payload) };
    case SERVICEORDER_FIND_REQUEST_FAIL:
      return state;
    case SERVICEORDER_CANCEL:
      return state;
    case SERVICEORDER_BILL:
      return state;
    case RESET_SERVICE_ORDER:
      return (initialValue.serviceOrder = {});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/serviceOrder/serviceOrder.reducer.js